import React, { useState, useEffect } from "react";
import "./admincontrols.css";
import Loading1 from '../../loading_animation/loading';

const ManageDomain = () => {
  const [activeForm, setActiveForm] = useState(""); 
  const [categories, setCategories] = useState([]);
  const [domains, setDomains] = useState([]);
  const [formData, setFormData] = useState({
    category: "",
    domain: "",
    newDomain: ""
  });
  const [config, setConfig] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  // Load config.json
  useEffect(() => {
    fetch("/config.json")
      .then(res => res.json())
      .then(data => setConfig(data))
      .catch(err => console.error("Failed to load config.json:", err));
  }, []);

  // Fetch categories
  useEffect(() => {
    if (!config) return;
    fetch(`${config.BASE_URL}${config.GET_CATEGORIES}`, { method: "POST" })
      .then(res => res.json())
      .then(data => setCategories(data.categories || []))
      .catch(err => console.error("Failed to fetch categories:", err));
  }, [config]);

  // Fetch domains for update when category changes
  useEffect(() => {
    if (!config || activeForm !== "update" || !formData.category) {
      setDomains([]);
      return;
    }

    fetch(`${config.BASE_URL}${config.GET_DOMAINS}`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ category_name: formData.category })
    })
      .then(res => res.json())
      .then(data => {
        if (data.success) {
          setDomains(data.domains || []);
        } else {
          console.error("Failed to fetch domains:", data.message);
          setDomains([]);
        }
      })
      .catch(err => {
        console.error("Failed to fetch domains:", err);
        setDomains([]);
      });
  }, [activeForm, formData.category, config]);

  const handleAddNewClick = () => {
    setActiveForm("add");
    setFormData({ category: "", domain: "", newDomain: "" });
    setDomains([]);
  };

  const handleUpdateClick = () => {
    setActiveForm("update");
    setFormData({ category: "", domain: "", newDomain: "" });
    setDomains([]);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleDomainSelectChange = (e) => {
    setFormData(prev => ({ ...prev, domain: e.target.value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!config) return;

    const endpoint = activeForm === "add"
      ? config.ADD_DOMAIN   
      : config.UPDATE_DOMAINS;

    const payload = activeForm === "add"
      ? {
          category_name: formData.category,
          domain_name: formData.domain
        }
      : {
          category_name: formData.category,
          domain_name: formData.domain,
          new_domain_name: formData.newDomain
        };
    setIsLoading(true);
    fetch(`${config.BASE_URL}${endpoint}`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(payload)
    })
      .then(res => res.json())
      .then(data => {
        alert(data.message || "Action completed");
        setFormData({ category: "", domain: "", newDomain: "" });
        setDomains([]);
      })
      .catch(err => console.error("Failed to submit form:", err))
      .finally(() => setIsLoading(false));
  };

  return (
    <div className="manage-category-container">
      <h2>Manage Domains</h2>

      <div className="button-group">
        <button className="btn add-btn" onClick={handleAddNewClick}>
          Add New
        </button>
        <button className="btn update-btn" onClick={handleUpdateClick}>
          Update
        </button>
      </div>

      {activeForm && (
        <form className="category-form" onSubmit={handleSubmit}>
          <label>
            Select Category:
            <select
              name="category"
              value={formData.category}
              onChange={handleChange}
              required
            >
              <option value="">--Select--</option>
              {categories.map(cat => (
                <option key={cat.id} value={cat.category_name}>
                  {cat.category_name}
                </option>
              ))}
            </select>
          </label>

          <label>
            {activeForm === "add" ? "Enter Domain:" : "Select Domain:"}
            {activeForm === "add" ? (
              <input
                type="text"
                name="domain"
                value={formData.domain}
                onChange={handleChange}
                placeholder="Enter domain"
                required
              />
            ) : (
              <select
                name="domain"
                value={formData.domain}
                onChange={handleDomainSelectChange}
                required
              >
                <option value="">--Select Domain--</option>
                {domains.map(d => (
                  <option key={d.id} value={d.domain_name}>
                    {d.domain_name}
                  </option>
                ))}
              </select>
            )}
          </label>

          {activeForm === "update" && (
            <label>
              Enter New Domain:
              <input
                type="text"
                name="newDomain"
                value={formData.newDomain}
                onChange={handleChange}
                placeholder="Enter new domain name"
                required
              />
            </label>
          )}

          <button type="submit" className="submit-btn">
            {activeForm === "add" ? "Add Domain" : "Update Domain"}
          </button>
        </form>
      )}

         {isLoading && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            backgroundColor: "rgba(0, 0, 0, 0.5)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 9999
          }}
        >
          <Loading1 />
        </div>
      )}
      
    </div>
  );
};

export default ManageDomain;
